/**
 * プレースホルダーを置換する
 * - {{key}} → params[key] の値に単純置換
 * - {{key|singular|plural}} → params[key] === 1 ? singular : plural
 */
export const replaceParams = (
    text: string,
    params: Record<string, string | number>
): string => {
    return text.replace(
        /\{\{(\w+)(?:\|([^|}]+)\|([^}]+))?\}\}/g,
        (_, key, singular, plural) => {
            const value = params[key]
            if (value === undefined) return `{{${key}}}`
            if (singular !== undefined && plural !== undefined) {
                return value === 1 ? singular : plural
            }
            return String(value)
        }
    )
}
